<template>
  <div class="ph-bar">
    <!-- 左侧: 标题 + 数量 + 操作按钮(actions 插槽) -->
    <div class="ph-left">
      <h1 class="ph-title">{{ title }}</h1>
      <span v-if="count !== null && count !== undefined" class="ph-count">
        共 {{ count }} {{ unit }}
      </span>
      <slot name="actions" />
    </div>
    <!-- 右侧: 筛选/搜索(默认插槽) -->
    <div class="ph-right">
      <slot />
    </div>
  </div>
</template>

<script>
/**
 * 统一的页面顶部栏 — 标题、计数、操作按钮、筛选/搜索 全在一行。
 *
 * 用法:
 * <page-header title="项目管理" :count="total" unit="个">
 *   <template #actions>
 *     <el-button type="primary" size="small" icon="el-icon-plus" @click="create">创建</el-button>
 *   </template>
 *   <el-select ... />
 *   <el-input ... />
 * </page-header>
 */
export default {
  name: 'PageHeader',
  props: {
    title: { type: String, required: true },
    count: { type: [Number, String], default: null },
    unit: { type: String, default: '条' }
  }
};
</script>

<style lang="scss" scoped>
.ph-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 12px;
  padding: 14px 20px;
  margin-bottom: 14px;
  background: #fff;
  border: 1px solid #eef0f6;
  border-radius: 10px;

  .ph-left {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-shrink: 0;

    .ph-title {
      font-size: 18px;
      font-weight: 700;
      color: #1a1a2e;
      margin: 0;
      line-height: 1.2;
      letter-spacing: -0.3px;
    }

    .ph-count {
      font-size: 12px;
      color: #8f9bb3;
      padding: 2px 8px;
      background: #f4f5f7;
      border-radius: 10px;
      font-weight: 500;
    }
  }

  .ph-right {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    justify-content: flex-end;

    /* 只给"直接放进 ph-right 的"控件设默认宽度, 避免穿透到 el-select 内部的 .el-input */
    /* el-select 默认 160px, 组件内 inline style 可以覆盖 (例如 SourceFilter 120px) */
    & > ::v-deep .el-select {
      width: 160px;
    }
    /* 直接子级 el-input(非 el-select 内部那个)默认 160px */
    & > ::v-deep .el-input {
      width: 160px;
    }
    /* 搜索框单独再宽一点 */
    & > ::v-deep .ph-search {
      width: 220px;
    }
  }
}

@media (max-width: 900px) {
  .ph-bar {
    .ph-right {
      width: 100%;
      justify-content: flex-start;
    }
  }
}
</style>
